import { useState } from "react"

export default function useShowDays(initialShowDays) {
  const [showDays, setShowDays] = useState(initialShowDays)
  const dayWidth = showDays ? 35 : 7

  return [dayWidth, showDays, setShowDays]
}
